import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import HeaderImage from "../assets/images/codice_contatto_totem_sfondo.png";
import { FiArrowLeft } from "react-icons/fi";
import { EncounterLoginComponentTotem } from "../components/EcounterLoginComponentTotem";
import { useIntl } from "react-intl";

export const CodiceContattoTotem = ({ history }) => {

    const intl = useIntl();

    const textStyleNormal = {
        fontSize: "150%",
        textAlign: "center",
        color: "#fff",
    }

    return (
        <React.Fragment>
            <Container
                fluid="true"
                style={{
                    backgroundImage: `url(${HeaderImage})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100%",
                    backgroundColor: "#F5F5F5",
                    minHeight: '100vh'
                }}
            >
                <Row>
                    <Col md={3}>
                        <Button className="m-4 btn-lg w-100" style={{ background: "rgba(254,254,254, 0.5)", border: "none" }} onClick={() => history.goBack()}>
                            <b>
                                <FiArrowLeft style={{ fontSize: "200%", marginRight: "10%", verticalAlign: "bottom" }} />
                                <span style={textStyleNormal}>{intl.formatMessage({ id: "codContattoPageTotem.back" })}</span>
                            </b>
                        </Button>
                    </Col>
                </Row>
                <Row><br /></Row>
                <Row><br /></Row>
                <Row><br /></Row>
                <Row className="m-2">
                    <Col className="font-weight-bold" style={{ fontSize: "250%", textAlign: "center", color: "#fff" }}>
                        {intl.formatMessage({ id: "codContattoPageTotem.statusLabel" })}
                    </Col>
                </Row>
                <Row className="m-2">
                    <Col style={textStyleNormal}>
                        {intl.formatMessage({ id: "codContattoPageTotem.registrationLabel" })}
                    </Col>
                </Row>
                <Row className="m-3">
                    <Col>
                        <EncounterLoginComponentTotem history={history} />
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    )
}